import React from "react";
import awsRegions from "../aws/regions";

import styles from "./Styles.module.scss";
import { AzureIcon, GcpIcon, AwsIcon, AwsCircleIcon, AzureCircleIcon, GcpCircleIcon, OnpremCircleIcon, OnpremIcon } from "@netapp/bxp-design-system-react/icons/custom";
import { OracleIcon } from "@netapp/bxp-style/react-icons/Logo";

// OracleIcon is padded inside a 48x48 box; the tighter viewBox keeps it sized like the other provider icons.
const OciIcon = props => <OracleIcon width={36} height={22} {...props} viewBox="9.7 14.9 28.3 18"/>;

const OciCircleIcon = props => <svg role="img" aria-labelledby="OciCircleIcon" xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none" {...props}>
    <desc id="OciCircleIcon">Oracle Cloud Infrastructure</desc>
    <path d="M32.5 64.5C50.1731 64.5 64.5 50.1731 64.5 32.5C64.5 14.8269 50.1731 0.5 32.5 0.5C14.8269 0.5 0.5 14.8269 0.5 32.5C0.5 50.1731 14.8269 64.5 32.5 64.5Z" fill="var(--background-content)" stroke="var(--icon-round-border)" className="circle-icon-shadow"/>
    <OracleIcon x={3} y={3} width={59} height={59}/>
</svg>;

const allRegions = {
    aws: awsRegions
}

export const regionLabel = (provider, regionOrLocation) => {
    return allRegions[provider]?.[regionOrLocation] || regionOrLocation;
}

export const providersMap = {
    aws: { label: "AWS", longLabel: "Amazon Web Services", icon: AwsIcon, circleIcon: AwsCircleIcon, tableIconClassName: styles['aws-icon'] },
    azure: { label: "Azure", longLabel: "Microsoft Azure", icon: AzureIcon, circleIcon: AzureCircleIcon, tableIconClassName: styles['azure-icon'] },
    gcp: { label: "Google Cloud", longLabel: "Google Cloud Platform", icon: GcpIcon, circleIcon: GcpCircleIcon, tableIconClassName: styles['gcp-icon'] },
    oci: { label: "OCI", longLabel: "OCI NetApp Storage Service", icon: OciIcon, circleIcon: OciCircleIcon, tableIconClassName: styles['oci-icon'] },
    "on-prem": { label: "On-Premises", longLabel: "On-Premises", icon: OnpremIcon, circleIcon: OnpremCircleIcon, tableIconClassName: styles['on-prem-icon'] }
};

export const providerAddWEURLPath = (provider, featuresByKey, isHa, params) => {
    const cvoAwsKey = "NetApp.OntapCVO/new-create-cvo-AWS"; 
    const cvoGcpKey = "NetApp.OntapCVO/new-create-cvo-GCP"; 
    const cvoAzureKey = "NetApp.OntapCVO/new-create-cvo-AZURE"; 
    const ha = isHa ? '-ha' : '';
    const isCreate = params?.createOrDiscover === 'create' || params?.createOrDiscover === 'create-ha';
    const urlPath = {
        cvo: {
            aws: '/add-new-working-environment/cvo/aws',
            gcp: '/add-new-working-environment/cvo/gcp',
            azure: '/add-new-working-environment/cvo/azure',
            angular: '/add-new-working-environment-wizard'
        }
    };
    
    if(isCreate && provider === 'aws' && featuresByKey[cvoAwsKey]?.active) {
        return urlPath.cvo.aws + ha;
    } else if (isCreate && provider === 'gcp' && featuresByKey[cvoGcpKey]?.active) {
        return urlPath.cvo.gcp + ha;
    } else if (isCreate && provider === 'azure' && featuresByKey[cvoAzureKey]?.active) {
        return urlPath.cvo.azure + ha;
    } else {
        return urlPath.cvo.angular
    }
}
